import { render, staticRenderFns } from "./pay-comp.vue?vue&type=template&id=3cb08fd6&scoped=true&"
import script from "./pay-comp.vue?vue&type=script&lang=ts&"
export * from "./pay-comp.vue?vue&type=script&lang=ts&"
import style0 from "./pay-comp.vue?vue&type=style&index=0&id=3cb08fd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb08fd6",
  null
  
)

export default component.exports